import microApp from '@micro-zoe/micro-app'
/** @jsxRuntime classic */
/** @jsx jsxCustomEvent */
import jsxCustomEvent from '@micro-zoe/micro-app/polyfill/jsx-custom-event'
import { checkFunctionCode } from '@mk/core'
/**
 * 创建基座路由
 * @param navs
 */
export const createModuleRoutes = () => {
  // 加载所有模块路由
  const files = (require as any).context('./modules', false, /\.tsx$/)
  const moduleRoutes = [] as any
  files.keys().forEach((key: string) => {
    const item = files(key)
    moduleRoutes.push(...item.default)
  })

  return checkFunctionCode(moduleRoutes)
}

/**
 * 创建微前端路由
 * @returns
 */
export const createMicroAppRoutes = () => {
  const { org = {} } = microApp.getGlobalData() || {}
  const { apps = [] } = (org || {}) as any

  const microRoutes = []

  for (const app of apps) {
    if (app.isMain || !app.url) {
      continue
    }

    microRoutes.push({
      id: Symbol(app.code),
      path: `${app.baseRoute}*`,
      element: (
        <micro-app
          name={app.code}
          url={app.url}
          baseroute={app.baseRoute}
          destroy={true}
          onCreated={() => {
            console.log(`${app.name} 创建了`)
          }}
          onBeforemount={() => {
            console.log(`${app.name} 即将被渲染`)
          }}
          onMounted={() => {
            console.log(`${app.name} 已经渲染完成`)
          }}
          onUnmount={() => {
            console.log(`${app.name} 卸载了`)
          }}
          onError={() => {
            console.log(`${app.name} 加载出错了`)
          }}
          onDataChange={(e: CustomEvent) => {
            console.log(`来自子应用 ${app.name} 的数据: ${app.name} 即将被渲染`, e.detail.data)
          }}
        ></micro-app>
      )
    })
  }

  return microRoutes
}
